import { Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { GetScannerQuery as GetScanner } from '__generated__/graphql';

import { encodeUrl } from '../../../common/helpers';
import EditScannerCriteriaForm from './EditScannerCriteriaForm';
import EditScannerInfoForm from './EditScannerInfoForm';
import UI from '../../../common/UI';
import useProject from '../../useProject';

type Scanner = GetScanner['project']['scanner'];

export interface EditScannerFormProps {
  scanner: Scanner;
}

const EditScannerForm = ({ scanner }: EditScannerFormProps) => {
  const { t } = useTranslation();
  const project = useProject();

  return (
    <UI.FormGrid sc={{ columns: ['1fr', '1fr 3fr'], gutter: 1.5 }}>
      <UI.Nav>
        <UI.NavLink
          to={`/${project.id}/participants/scanners/${scanner.id}?${encodeUrl({ event: scanner.event.id })}`}
          exact
        >
          {t('basic_info')}
        </UI.NavLink>
        <UI.NavLink
          to={`/${project.id}/participants/scanners/${scanner.id}/criteria?${encodeUrl({ event: scanner.event.id })}`}
        >
          {t('criteria')}
        </UI.NavLink>
      </UI.Nav>

      <UI.Div>
        <Switch>
          <Route path="/:projectId/participants/scanners/:scannerId/criteria">
            <EditScannerCriteriaForm scanner={scanner} />
          </Route>
          <Route path="/:projectId/participants/scanners/:scannerId">
            <EditScannerInfoForm scanner={scanner} />
          </Route>
        </Switch>
      </UI.Div>
    </UI.FormGrid>
  );
};

export default EditScannerForm;
